export default {
	cafeteriaV3: {
		55555: '0x7aaA2A556578541067BFE93EE05B962Ee57E21CB',
	},
	multiCall: {
		55555: '0x6e2A64fE96732C8D4cA9DfF8DAf3178C25D2b434',
	},
}
